import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { ErrorNote, Loading, Page } from "./common";

const STATUS_TONE: Record<string, { bg: string; fg: string }> = {
  Operational: { bg: "#e8f4ee", fg: "#1f8a5b" },
  Degraded: { bg: "#fbf2dc", fg: "#9a6a12" },
  Down: { bg: "#fbe9e7", fg: "#b3261e" },
};

export function Vendors() {
  const { data, isLoading, error } = useQuery({ queryKey: ["vendors"], queryFn: api.vendors });
  if (isLoading) return <Loading />;
  if (error || !data) return <ErrorNote error={error} />;

  return (
    <Page>
      <div>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px" }}>Vendors</h1>
        <div style={{ fontSize: 14, color: "#8a8e88", marginTop: 3 }}>Third parties and integrations, with current status</div>
      </div>
      <div style={{ background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", overflow: "hidden" }}>
        {data.map((v) => {
          const st = STATUS_TONE[v.status] ?? { bg: "#f0efe9", fg: "#6b706a" };
          return (
            <div key={v.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "13px 18px", borderTop: "1px solid #f4f3ee" }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13.5, fontWeight: 600 }}>{v.name}</div>
                <div style={{ fontSize: 11.5, color: "#8a8e88" }}>{v.category}</div>
              </div>
              <span style={{ fontSize: 10.5, fontWeight: 600, padding: "3px 9px", borderRadius: 999, background: st.bg, color: st.fg }}>{v.status}</span>
            </div>
          );
        })}
      </div>
    </Page>
  );
}
